import { z } from 'zod'

export const consentsOptionsSchema = z.object({
  invalid_message: z.string()
})

export const consentFieldConstraintSchema = z.object({
  name: z.string()
})

export const consentsFieldOptionsSchema = z.object({
  label: z.string().nullish(),
  type: z.string().nullish(),
  constraints: z.array(consentFieldConstraintSchema).nullish(),
  data: z.number().nullish(),
  required: z.boolean().nullish()
})

export const consentsFieldSchema = z.object({
  name: z.string(),
  type: z.string(),
  options: consentsFieldOptionsSchema
})

export const consentsFieldsSchema = z.array(consentsFieldSchema)

export const consentFieldsetSchema = z.object({
  name: z.string(),
  fields: consentsFieldsSchema
})

export const consentsResponseSchema = z.object({
  name: z.string(),
  options: consentsOptionsSchema,
  fields: consentsFieldsSchema,
  fieldsets: z.array(consentFieldsetSchema)
})
